import { Component, Input } from "@angular/core";
import { Nullable } from "ng/src/app/shared/model/app.model";

@Component({
	selector: 'lb-loading-indicator',
	template: `
        <div class="p-d-flex p-flex-column p-jc-center p-ai-center">
            <p-progressSpinner></p-progressSpinner>
            <label *ngIf="label">{{label}}</label>
        </div>
	`
})
export class LoadingIndicatorComponent {
	@Input() label: Nullable<string> = null;
}